import { Talk } from "./talk";

export class FirebaseTalk extends Talk {
  sender: number;
  message: string;
  is_first_talk: boolean;
  read_at: Date;
  content: string;

  constructor(fields: any) {
    super(fields);
    for (const f in fields) {
      this[f] = fields[f];
    }
  }

  getUserId(): number {
    return this.sender;
  }

  getFreeText(): string {
    return this.message;
  }

  hasFreeText(): boolean {
    return !!this.message;
  }

  setIsFirstTalk(flag: boolean): void {
    this.is_first_talk = flag;
  }
}



// WEBPACK FOOTER //
// ./src/models/firebase-talk.ts